"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inverse = exports.Inverse = exports.conjugate = exports.Conjugate = exports.power = exports.Power = exports.divide = exports.Divide = exports.multiply = exports.Multiply = exports.argument = void 0;
const abs = Math.abs;
const sin = Math.sin;
const cos = Math.cos;
const atan2 = Math.atan2;
const TURN = 2.0 * Math.PI;
function fill(r) {
    return {
        [Symbol.iterator]: () => ({
            next() {
                const value = { x: 0.0, y: 0.0 };
                r.push(value);
                return { value, done: false };
            }
        })
    };
}
/**
 * φ
 */
function argument(z) {
    return atan2(z.y, z.x);
}
exports.argument = argument;
/**
 * zw, z = a + bi, w = c + di
 */
function Multiply(z, w) {
    return multiply({ x: 0.0, y: 0.0 }, z, w);
}
exports.Multiply = Multiply;
/**
 * r⃗ = zw, z = a + bi, w = c + di
 */
function multiply(r, z, w) {
    const { x: a, y: b } = z;
    const { x: c, y: d } = w;
    r.x = a * c - b * d;
    r.y = a * d + b * c;
    return r;
}
exports.multiply = multiply;
/**
 * zw̅ / ww̅, z = a + bi, w = c = di
 */
function Divide(z, w) {
    return divide({ x: 0.0, y: 0.0 }, z, w);
}
exports.Divide = Divide;
/**
 * r⃗ = zw̅ / ww̅, z = a + bi, w = c = di
 */
function divide(r, z, w) {
    const { x: a, y: b } = z;
    const { x: c, y: d } = w;
    const den = 1.0 / (Math.pow(c, 2) + Math.pow(d, 2));
    r.x = (a * c + b * d) * den;
    r.y = (b * c - a * d) * den;
    return r;
}
exports.divide = divide;
/**
 * zⁿ₍ₖ₎
 */
function Power(z, n) {
    const r = [];
    power(fill(r), z, n);
    return r;
}
exports.Power = Power;
/**
 * r⃗₍ₖ₎ = zⁿ₍ₖ₎
 */
function power(r, z, n) {
    const { x: a, y: b } = z;
    const mod = Math.pow((Math.pow(a, 2) + Math.pow(b, 2)), (n * 0.5));
    const arg = atan2(b, a) * n;
    const arc = (n !== 0.0 ? abs(n) : 1.0) * TURN;
    let k = 0.0;
    for (const w of r) {
        if (w !== undefined) {
            const argk = arg + k;
            w.x = mod * cos(argk);
            w.y = mod * sin(argk);
        }
        k += arc;
        if (k >= TURN)
            break;
    }
    return r;
}
exports.power = power;
/**
 * z̅
 */
function Conjugate(z) {
    return { x: z.x, y: -z.y };
}
exports.Conjugate = Conjugate;
/**
 * r⃗ = z̅
 */
function conjugate(r, v) {
    r.x = v.x;
    r.y = -v.y;
    return r;
}
exports.conjugate = conjugate;
/**
 * z⁻¹
 */
function Inverse(z) {
    return inverse({ x: 0.0, y: 0.0 }, z);
}
exports.Inverse = Inverse;
/**
 * r⃗ = z⁻¹
 */
function inverse(r, z) {
    const { x: a, y: b } = z;
    const den = 1.0 / (Math.pow(a, 2) + Math.pow(b, 2));
    r.x = a * den;
    r.y = -b * den;
    return r;
}
exports.inverse = inverse;
